import { actions as actions$1 } from '@grandvisionhq/state';

const pushEvent = actions$1.action('analytics/data-layer/push-event', function(payload) {
    return {
        payload
    };
});

export { pushEvent };
//# sourceMappingURL=actions.js.map
